import React from 'react';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';
import * as _ from 'es-toolkit';

import './PlacesField.css';

const PlacesField = ({ name, places, onChange, single, defaultValue, disabled }) => {
    const options = places?.length > 0 ? _.sortBy(places.map(place => {
        return {
            key: place._id,
            text: place.name,
            value: place._id
        };
    }), 'text') : [];

    const onFieldChange = (value) => {
        return onChange ? onChange(value) : true;
    }

    return single ? (
        <SelectField
            name={ name }
            options={ options }
            onSelectChange={ onFieldChange }
            defaultValue={defaultValue}
            disabled={disabled}
            clearable
        />
    ) : (
        <MultiSelectField
            name={ name }
            options={ options }
            onSelectChange={ onFieldChange }
            defaultValue={defaultValue}
            disabled={disabled}
        />
    );
}

export default PlacesField;
